"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFormComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const multiselect_dropdown_1 = require("./multiselect-dropdown");
const show_hide_input_directive_1 = require("./show-hide-input.directive");
//VARIABLE MODELS
const user_1 = require("./user");
const organization_1 = require("./organization");
const rxjs_1 = require("rxjs");
const ng2_select_1 = require("ng2-select/ng2-select");
let UserFormComponent = class UserFormComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this.onUserCreated = new core_1.EventEmitter();
        this.organizationSearchDelay = 30;
        this.organizationSearchLimit = 10;
        this.errors = {
            client: null,
            server: null,
        };
        this.showPassword = false;
        this.passwordContraints = `
    <ul class="card card-text popoverList">
      <li>8 or more characters</li>
      <li>at least one lowercase letter</li>
      <li>at least one uppercase letter</li>
      <li>at least one number</li>
      <li>at least one symbol from the following list: $@$!.%*?&</li>
    </ul>
  `;
        this.user = new user_1.User();
    }
    ngOnInit() {
        this.initListeners();
    }
    initListeners() {
        const eventStream = rxjs_1.Observable.fromEvent(this._elementRef.nativeElement, "keyup")
            .map(() => this.organizationSearchText)
            .debounceTime(this.organizationSearchDelay)
            .distinctUntilChanged();
        eventStream.subscribe((input) => __awaiter(this, void 0, void 0, function* () {
            this.organizations = yield organization_1.Organization.list({
                displayName: input,
                limit: this.organizationSearchLimit,
            });
        }));
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.errors.server = null;
            this.errors.client = this.user.validate();
            if (this.errors.client.length !== 0) {
                this.success = null;
                return;
            }
            try {
                yield this.user.create();
                this.user = new user_1.User();
                this.success = "User Successfully Created";
                this.errors.client = null;
                this.errors.server = null;
                this.onUserCreated.emit();
                this.orgSelect.active = [];
                this.rolesSelect.uncheckAll();
            }
            catch (err) {
                this.success = null;
                this.errors.server = err;
            }
        });
    }
    organizationSelected($event) {
        this.user.organization = $event.id;
    }
    organizationUnselected($event) {
        delete this.user.organization;
    }
    organizationSearchChanged($event) {
        if ($event) {
            this.organizationSearchText = $event;
        }
        else {
            this.organizationSearchText = null;
        }
    }
    toggleViewPassword() {
        this.showPassword = !this.showPassword;
        if (this.showPassword) {
            this.input.forEach(child => {
                child.changeType("text");
            });
        }
        else {
            this.input.forEach(child => {
                child.changeType("password");
            });
        }
    }
    generatePassword() {
        this.user.generatePassword();
    }
};
exports.UserFormComponent = UserFormComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], UserFormComponent.prototype, "permission", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], UserFormComponent.prototype, "roles", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], UserFormComponent.prototype, "onUserCreated", void 0);
__decorate([
    (0, core_1.ViewChildren)(show_hide_input_directive_1.ShowHideInputDirective),
    __metadata("design:type", core_1.QueryList)
], UserFormComponent.prototype, "input", void 0);
__decorate([
    (0, core_1.ViewChild)(ng2_select_1.SelectComponent),
    __metadata("design:type", ng2_select_1.SelectComponent)
], UserFormComponent.prototype, "orgSelect", void 0);
__decorate([
    (0, core_1.ViewChild)(multiselect_dropdown_1.MultiselectDropdown),
    __metadata("design:type", multiselect_dropdown_1.MultiselectDropdown)
], UserFormComponent.prototype, "rolesSelect", void 0);
exports.UserFormComponent = UserFormComponent = __decorate([
    (0, core_1.Component)({
        selector: "user-form",
        templateUrl: "app/user-form.component.html",
        styleUrls: ["styles/admin.component.css"],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [core_1.ElementRef])
], UserFormComponent);
//# sourceMappingURL=user-form.component.js.map